import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=654b57ea&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654b57ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('654b57ea')) {
      api.createRecord('654b57ea', component.options)
    } else {
      api.reload('654b57ea', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=654b57ea&scoped=true&", function () {
      api.rerender('654b57ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2CwgHlJIak6AM/JS/comp/SearchFilterTokens.vue"
export default component.exports